<template>
    <div class="jiaoshi_wrap">
        <h4>教室列表</h4>
        <table class="table" border="1">
            <tr>
                <th>项目类型</th>
                <th>教室名称</th>
                <!--<th>定额人数</th>-->
            </tr>
            <tr v-for="(item, index) in tableData" :key="index">
                <td>
                    {{item.item_name}}
                </td>
                <td style="position:relative">
                    <input type="text" v-model="item.content" @focus="showBtn=index">
                    <el-button class="saveBtn" type="warning" size="mini" v-show="showBtn==index"
                               @click="saveclass(item.id,item.content)">保存
                    </el-button>
                </td>
                <!--<td style="position:relative">-->
                <!--<input type="text" v-model="item.number" @focus="showBtn=index">-->
                <!--<el-button class="saveBtn" type="warning" size="mini" v-show="showBtn==index" @click="savePeople(item.id,item.number)">保存</el-button>-->
                <!--</td>-->
            </tr>
        </table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                showBtn: -1,  // 判断保存按钮是否显示
                token: '',
                tableData: []
            };
        },
        created() {
            this.token = this.$cookies.get('token');
            this.get_data();
        },
        methods: {
            // 获取数据
            get_data() {
                let self = this;
                $.ajax({
                    url: process.env.apiUrl + 'saas/Setclass/index',
                    type: 'post',
                    data: {
                        token: self.token
                    },
                    success: function (data) {
                        if (data.status == 1) {
                            self.tableData = data.data
                        }
                    }
                })

            },
            //修改班级名称
            saveclass(id, class_name) {
                let self = this;
                $.ajax({
                    url: process.env.apiUrl + 'saas/Setclass/edit_class_name',
                    type: 'post',
                    data: {
                        token: self.token,
                        id: id,
                        class_name: class_name
                    },
                    success: function (data) {
                        if (data.status == 1) {
                            self.$message({
                                message: "设置成功",
                                type: 'success'
                            });
                            self.showBtn = -1
                            self.get_data();
                        } else {
                            self.$message({
                                message: data.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            //修改定额人数
            savePeople(id, number) {
                let self = this;
                $.ajax({
                    url: process.env.apiUrl + 'saas/Setclass/edit',
                    type: 'post',
                    data: {
                        token: self.token,
                        id: id,
                        number: number
                    },
                    success: function (data) {
                        if (data.status == 1) {
                            self.$message({
                                message: "设置成功",
                                type: 'success'
                            });
                            self.showBtn = -1
                            self.get_data();
                        } else {
                            self.$message({
                                message: data.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            }
        }
    };
</script>
<style scoped>
    .jiaoshi_wrap {
        padding: 20px;

    }

    h4::before {
        display: inline-block;
        content: '';
        margin-right: 3px;
        width: 3px;
        height: 19px;
        vertical-align: middle;
        background: #199ed8;
    }

    .table {
        margin: auto;
        margin-top: 20px;
        width: 100%;
        max-width: 840px;
        font-size: 14px;
        text-align: center;
    }

    .table tr {
        height: 40px;
    }

    .table th {
        text-align: center;
        background: #f1f1f1;
    }

    .table td {
        width: 33.3%;
    }

    .table input {
        border: none;
        width: 40%;
        height: 40px;
        text-align: center;
    }

    .saveBtn {
        position: absolute;
        top: 6px;
        right: 5%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/xitong/jiaoshi.vue